import React, { useRef,useCallback,useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';


const Companies = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState(0);
    const [companyName, setCompanyName] = useState(null);
    const [shortName, setShortName] = useState(null);
    const [address, setAddress] = useState(null);
    const [pincode, setPincode] = useState(null);
    const [gstNumber, setGstNumber] = useState(null);
    const [licenceNumber, setLicenceNumber] = useState(null);
    const [bgAmount, setBgAmount] = useState('');
    const [gracePercent, setGracePercent] = useState('95');

    const api = useApi();
    const gridRef = useRef();

    const loadCompanies = async () => {
       await api.getCompanies().then((data) => {
            setCompanies(data);
        })
    }

    useEffect(() => {
        loadCompanies();
    }, []);


    const linkRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => editCompany(props.data)}>{cellValue}</span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };


    const columns = [
        { headerName: '#', field: 'companyId', headerClass: 'text-center', cellClass: 'text-center', cellRenderer: (props) => { return <span>{props.rowIndex + 1}</span> }, width: 40 },
        { headerName: 'Company Name', field: 'companyName', cellRenderer: linkRenderer,  flex:1 },
        { headerName: 'Short Name', field: 'shortName',width:100 },
        { headerName: 'Address', field: 'address', width:260 },
        { headerName: 'Pincode', field: 'pincode', headerClass: 'text-center', cellClass: 'text-center', width: 90 },
        { headerName: 'GST Number', field: 'gstNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'Licence Number', field: 'licenceNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'BG Amount', field: 'bgAmount', width: 100, headerClass: 'text-center', cellClass: 'text-center', cellRenderer: amountRenderer },
        { headerName: 'Grace %', field: 'gracePercent', width: 100, headerClass: 'text-center', cellClass: 'text-center', },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };



    const addNewCompany = () => {
        setCompanyId(0);
        setCompanyName(null);
        setShortName(null);
        setAddress(null);
        setPincode(null);
        setGstNumber(null);
        setLicenceNumber(null);
        setBgAmount(null);
        setGracePercent(null);
        setModalVisible(true);
    }
    const editCompany = (cmp) => {
        setCompanyId(cmp.companyId);
        setCompanyName(cmp.companyName);
        setShortName(cmp.shortName);
        setAddress(cmp.address);
        setPincode(cmp.pincode);
        setGstNumber(cmp.gstNumber);
        setLicenceNumber(cmp.licenceNumber);
        setBgAmount(cmp.bgAmount);
        setGracePercent(cmp.gracePercent);
        setModalVisible(true);
    } 
     
    const handleClose = () => {
        setModalVisible(false);
    };

    const handleCompanyNameChange = (event) => {
        setCompanyName(event.target.value);
    };
    const handleShortNameChange = (event) => {
        setShortName(event.target.value);
    };
    const handleAddressChange = (event) => {
        setAddress(event.target.value);
    };
    const handlePincodeChange = (event) => {
        setPincode(event.target.value);
    };
    const handleGSTNumberChange = (event) => {
        setGstNumber(event.target.value);
    };
    const handleLicenceNumberChange = (event) => {
        setLicenceNumber(event.target.value);
    };
    const handleBgAmountChange = (event) => {
        setBgAmount(event.target.value);
    };
    const handleGracePercentChange = (event) => {
        setGracePercent(event.target.value);
    };

    const onSaveCompany = async () => {
        const params = {
            companyId,
            companyName,
            shortName,
            address,
            pincode,
            gstNumber,
            licenceNumber,
            bgAmount,
            gracePercent
        };

        await api.saveCompany(params).then((data) => {
            loadCompanies();
            setModalVisible(false);
        }).catch((error) => {
            console.error('Error saving company:', error);
        });
    };

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            document.getElementById("filter-text-box").value,
        );
    }, []);

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Companies</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={()=>navigate('/home') }>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Companies</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        <button type="button" className="btn btn-primary my-2 btn-icon-text" onClick={addNewCompany}>
                            <i className="fe fe-edit me-2"></i> Add New Company
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                       
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>

                                </div>
                                <div>
                                    <input type="text" className="form-control" id="filter-text-box" onChange={onFilterTextBoxChanged} placeholder="type to filter"></input>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine"
                                }
                            >
                                <AgGridReact
                                    ref={gridRef}
                                gridOptions={gridOptions}
                                rowData={companies}
                                />
                            </div>
                            {/*<div className="table-responsive border border-bottom-0 fixed-height-400">*/}

                            {/*    <table className="table table-hover table-striped text-nowrap table-vcenter  tx-13 mb-0">*/}
                            {/*        <thead>*/}
                            {/*            <tr>*/}
                            {/*                <th className="wd-lg-4p text-center">#</th>*/}
                            {/*                <th className="wd-lg-20p">Company Name </th>*/}
                            {/*                <th className="wd-lg-20p">Short Name</th>*/}
                            {/*                <th className="wd-lg-20p ">Address</th>*/}
                            {/*                <th className="min-w-24 ">Pincode</th>*/}
                            {/*                <th className="wd-lg-20p text-center">GST Number</th>*/}
                            {/*                <th className="wd-lg-20p text-center">Licence Number</th>*/}
                            {/*            </tr>*/}
                            {/*        </thead>*/}
                            {/*        <tbody>*/}
                            {/*            {companies?.length === 0 ?*/}
                            {/*                <tr><td className="text-center" colSpan="7">No records available.</td></tr>     */}
                            {/*            :null}*/}
                            {/*            {companies?.map((cmp, index) => {*/}
                            {/*                return <tr>*/}
                            {/*                    <td className="text-center"> {index + 1} </td>*/}
                            {/*                    <td><a href="#" onClick={() => editCompany(cmp)}> {cmp.companyName} </a></td>*/}
                            {/*                    <td>{cmp.shortName} </td>*/}
                            {/*                    <td>{cmp.address} </td>*/}
                            {/*                    <td className="text-center">{cmp.pincode} </td>*/}
                            {/*                    <td className="text-center">{cmp.gstNumber} </td>*/}
                            {/*                    <td className="text-center">{cmp.licenceNumber} </td>*/}
                            {/*                </tr>*/}
                            {/*            })}*/}
                            {/*        </tbody>*/}
                            {/*    </table>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modalVisible} size='lg' onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add/Edit Company</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                Company Name
                                <input className="form-control" placeholder="Company Name" type="text" value={companyName}
                                    onChange={handleCompanyNameChange} />
                            </div>

                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                Short Name
                                <input className="form-control" placeholder="Short Name" type="text" value={shortName}
                                    onChange={handleShortNameChange} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                Address
                                <textarea className="form-control" placeholder="Address" type="text" value={address}
                                    onChange={handleAddressChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                Pincode
                                <input className="form-control" placeholder="Pincode" type="number" value={pincode}
                                    onChange={handlePincodeChange} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                GST Number
                                <input className="form-control" placeholder="GST" type="text" value={gstNumber}
                                    onChange={handleGSTNumberChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                Licence Number
                                <input className="form-control" placeholder="Licence number" type="text" value={licenceNumber}
                                    onChange={handleLicenceNumberChange} />
                            </div>
                        </div>
                    </div>
                    {/*<div>*/}
                    {/*    <h6 className="main-content-label text-primary  bg-gray-200 pd-8">*/}
                    {/*        Bank guarantee detail*/}
                    {/*    </h6>*/}
                    {/*</div>*/}

                    {/*<div className="row">*/}
                    {/*    <div className="col-6">*/}
                    {/*        <div className="form-group">*/}
                    {/*            Bank guarantee amount*/}
                    {/*            <input className="form-control" min={0} placeholder="BG Amount" type="number" value={bgAmount}*/}
                    {/*                onChange={handleBgAmountChange} />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="col-6">*/}
                    {/*        <div className="form-group">*/}
                    {/*            Grace percentage*/}
                    {/*            <input className="form-control" min={0} placeholder="Grace percentage" type="number" value={gracePercent}*/}
                    {/*                onChange={handleGracePercentChange} />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="mg-t-10">
                        <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onSaveCompany}>
                            Save
                        </button>
                        <button className="btn ripple btn-light pd-x-30" onClick={handleClose}>
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Companies;



